export default function LimMultFormat(mult) {
    if(mult?.includes('/')) {
        return mult + ' xp';
    }
    return '×' + mult + ' xp';
}